import * as React from 'react';

import { CatalogActionContext, CatalogValueContext } from './context';
import { useCatalogAction, useCatalogValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const CatalogFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <CatalogValueContext.Provider value={state}>
      <CatalogActionContext.Provider value={dispatch}>
        {children}
      </CatalogActionContext.Provider>
    </CatalogValueContext.Provider>
  );
};

export { CatalogFormContext, useCatalogAction, useCatalogValue };
